import React from 'react';

const SplitMethodSelector = ({ selectedMethod, onMethodChange }) => {
  const methods = [
    {
      id: 'percent',
      label: 'Percent',
      icon: (
        <svg
          width='37'
          height='37'
          viewBox='0 0 37 37'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M16.5568 3.6244C17.8462 3.45621 19.1557 3.45996 20.4451 3.62721C22.949 3.95656 25.3681 4.92729 27.3951 6.43725C28.9433 7.57945 30.2664 9.02617 31.2731 10.6664C32.3084 12.3562 32.9978 14.2541 33.3029 16.212C33.3961 16.7639 33.4026 17.3261 33.5 17.8765V19.401C33.4639 19.4929 33.4255 19.5866 33.4251 19.6873C33.1644 23.2956 31.5156 26.7761 28.911 29.2807C26.49 31.6415 23.2457 33.1317 19.8802 33.4353C17.5359 33.6541 15.1391 33.3168 12.9526 32.4384C9.96754 31.2713 7.40374 29.0881 5.71981 26.3638C4.58955 24.5231 3.85944 22.436 3.60998 20.2893C3.55335 19.9646 3.56646 19.6329 3.5 19.3097V17.6549C3.53276 17.4774 3.55897 17.2984 3.56552 17.1176C3.80936 14.3876 4.82683 11.7299 6.47004 9.53683C7.00124 8.84252 7.5638 8.16507 8.22043 7.5846C8.8457 6.96666 9.5496 6.43538 10.2797 5.94861C12.1616 4.71412 14.3253 3.91252 16.5568 3.6244ZM17.7053 5.4773C14.5906 5.66189 11.5499 7.00929 9.3432 9.22294C7.4379 11.081 6.13915 13.5458 5.66131 16.1637C5.50686 17.0454 5.42496 17.9393 5.44836 18.8346C5.49048 19.9918 5.6688 21.149 6.00811 22.2584C6.88939 25.2221 8.87519 27.8368 11.482 29.4925C13.553 30.8305 16.0157 31.5421 18.4766 31.552C20.9603 31.5473 23.4474 30.8267 25.5329 29.4676C28.2011 27.7609 30.2103 25.0464 31.0466 21.9876C31.4566 20.5428 31.5933 19.0267 31.4851 17.5303C31.2698 14.4312 29.8789 11.4361 27.6727 9.25386C26.3519 7.94441 24.755 6.90669 23.0065 6.26953C21.3193 5.638 19.5015 5.37002 17.7053 5.4773Z'
            fill='#232F3E'
          />
          <path
            d='M21.903 9.4965C22.1978 9.45902 22.5123 9.45574 22.7814 9.60097C23.2368 9.77994 23.5527 10.2719 23.4966 10.7628C23.4437 11.0411 23.2939 11.2871 23.1727 11.5396C20.681 16.6523 18.1836 21.7617 15.6924 26.8749C15.5829 27.1096 15.3985 27.3144 15.1607 27.4226C14.9304 27.5477 14.6637 27.5402 14.41 27.5224C13.9687 27.4395 13.5751 27.1078 13.4529 26.6692C13.3476 26.4233 13.4131 26.1511 13.5278 25.9215C16.1 20.6388 18.6657 15.3522 21.2393 10.0704C21.3638 9.79071 21.6081 9.57942 21.903 9.4965Z'
            fill='#232F3E'
          />
          <path
            d='M12.6503 10.4023C13.233 10.3574 13.8307 10.3386 14.4035 10.4754C14.9464 10.5921 15.4912 10.8118 15.8834 11.2185C16.4174 11.7287 16.6397 12.4904 16.636 13.2138C16.6411 14.3377 16.6397 15.4616 16.6364 16.5856C16.6481 17.3459 16.4048 18.1466 15.8347 18.6727C15.3517 19.1389 14.6815 19.3371 14.0319 19.4261C13.1516 19.5207 12.2235 19.4659 11.4143 19.078C10.818 18.7941 10.3669 18.2436 10.1834 17.6111C9.98635 17.0405 10.0294 16.43 10.0252 15.8364C10.0266 14.9772 10.0224 14.1185 10.0275 13.2592C10.0289 12.5026 10.2578 11.7024 10.8232 11.173C11.3132 10.7017 11.9942 10.5031 12.6503 10.4023ZM13.0219 12.3143C12.8754 12.3508 12.728 12.401 12.6059 12.4928C12.3714 12.6685 12.2609 12.9735 12.2689 13.2602C12.2651 14.3527 12.2665 15.4457 12.2684 16.5383C12.2548 16.8189 12.3461 17.1159 12.5586 17.3075C12.7959 17.5104 13.1216 17.5661 13.4249 17.5493C13.775 17.5465 14.1461 17.3862 14.3155 17.0658C14.4587 16.8212 14.4367 16.5298 14.4386 16.2576C14.4363 15.2578 14.4424 14.2576 14.4353 13.2574C14.44 12.9163 14.2612 12.5532 13.9383 12.4136C13.657 12.267 13.3275 12.2768 13.0219 12.3143Z'
            fill='#232F3E'
          />
          <path
            d='M22.9791 17.5064C23.7233 17.4722 24.4969 17.4924 25.191 17.7936C25.6721 17.9754 26.0947 18.3169 26.3634 18.7573C26.6793 19.268 26.7977 19.8784 26.7902 20.4725C26.7911 21.52 26.7916 22.5671 26.7902 23.6142C26.7949 24.346 26.6053 25.1157 26.1008 25.6667C25.5514 26.2551 24.7342 26.5114 23.9498 26.5554C23.5159 26.6248 23.0769 26.5695 22.6445 26.5231C21.9982 26.4285 21.3406 26.1848 20.8843 25.6995C20.4359 25.2502 20.2323 24.6088 20.1832 23.9881C20.1687 22.8009 20.179 21.6137 20.1771 20.4266C20.1668 19.9388 20.2464 19.4418 20.4574 18.9995C20.6526 18.5652 20.9952 18.2031 21.4019 17.9604C21.883 17.684 22.4315 17.5622 22.9791 17.5064ZM23.1682 19.4324C22.9665 19.4699 22.7681 19.5566 22.6347 19.7168C22.432 19.9299 22.395 20.2392 22.3913 20.5203C22.3913 21.4568 22.3918 22.3938 22.3913 23.3308C22.3899 23.6259 22.381 23.9407 22.5261 24.2083C22.6613 24.4603 22.9337 24.6055 23.2099 24.6444C23.5426 24.6885 23.9105 24.6683 24.1974 24.4758C24.4768 24.2879 24.583 23.9342 24.5816 23.6128C24.5816 22.5498 24.583 21.4872 24.5812 20.4247C24.569 20.152 24.4993 19.8564 24.2844 19.6709C23.9929 19.3846 23.5464 19.3921 23.1682 19.4324Z'
            fill='#232F3E'
          />
        </svg>
      ),
      iconActive: (
        <svg
          width='37'
          height='37'
          viewBox='0 0 37 37'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M16.5568 3.6244C17.8462 3.45621 19.1557 3.45996 20.4451 3.62721C22.949 3.95656 25.3681 4.92729 27.3951 6.43725C28.9433 7.57945 30.2664 9.02617 31.2731 10.6664C32.3084 12.3562 32.9978 14.2541 33.3029 16.212C33.3961 16.7639 33.4026 17.3261 33.5 17.8765V19.401C33.4639 19.4929 33.4255 19.5866 33.4251 19.6873C33.1644 23.2956 31.5156 26.7761 28.911 29.2807C26.49 31.6415 23.2457 33.1317 19.8802 33.4353C17.5359 33.6541 15.1391 33.3168 12.9526 32.4384C9.96754 31.2713 7.40374 29.0881 5.71981 26.3638C4.58955 24.5231 3.85944 22.436 3.60998 20.2893C3.55335 19.9646 3.56646 19.6329 3.5 19.3097V17.6549C3.53276 17.4774 3.55897 17.2984 3.56552 17.1176C3.80936 14.3876 4.82683 11.7299 6.47004 9.53683C7.00124 8.84252 7.5638 8.16507 8.22043 7.5846C8.8457 6.96666 9.5496 6.43538 10.2797 5.94861C12.1616 4.71412 14.3253 3.91252 16.5568 3.6244ZM17.7053 5.4773C14.5906 5.66189 11.5499 7.00929 9.3432 9.22294C7.4379 11.081 6.13915 13.5458 5.66131 16.1637C5.50686 17.0454 5.42496 17.9393 5.44836 18.8346C5.49048 19.9918 5.6688 21.149 6.00811 22.2584C6.88939 25.2221 8.87519 27.8368 11.482 29.4925C13.553 30.8305 16.0157 31.5421 18.4766 31.552C20.9603 31.5473 23.4474 30.8267 25.5329 29.4676C28.2011 27.7609 30.2103 25.0464 31.0466 21.9876C31.4566 20.5428 31.5933 19.0267 31.4851 17.5303C31.2698 14.4312 29.8789 11.4361 27.6727 9.25386C26.3519 7.94441 24.755 6.90669 23.0065 6.26953C21.3193 5.638 19.5015 5.37002 17.7053 5.4773Z'
            fill='white'
          />
          <path
            d='M21.903 9.4965C22.1978 9.45902 22.5123 9.45574 22.7814 9.60097C23.2368 9.77994 23.5527 10.2719 23.4966 10.7628C23.4437 11.0411 23.2939 11.2871 23.1727 11.5396C20.681 16.6523 18.1836 21.7617 15.6924 26.8749C15.5829 27.1096 15.3985 27.3144 15.1607 27.4226C14.9304 27.5477 14.6637 27.5402 14.41 27.5224C13.9687 27.4395 13.5751 27.1078 13.4529 26.6692C13.3476 26.4233 13.4131 26.1511 13.5278 25.9215C16.1 20.6388 18.6657 15.3522 21.2393 10.0704C21.3638 9.79071 21.6081 9.57942 21.903 9.4965Z'
            fill='white'
          />
          <path
            d='M12.6503 10.4023C13.233 10.3574 13.8307 10.3386 14.4035 10.4754C14.9464 10.5921 15.4912 10.8118 15.8834 11.2185C16.4174 11.7287 16.6397 12.4904 16.636 13.2138C16.6411 14.3377 16.6397 15.4616 16.6364 16.5856C16.6481 17.3459 16.4048 18.1466 15.8347 18.6727C15.3517 19.1389 14.6815 19.3371 14.0319 19.4261C13.1516 19.5207 12.2235 19.4659 11.4143 19.078C10.818 18.7941 10.3669 18.2436 10.1834 17.6111C9.98635 17.0405 10.0294 16.43 10.0252 15.8364C10.0266 14.9772 10.0224 14.1185 10.0275 13.2592C10.0289 12.5026 10.2578 11.7024 10.8232 11.173C11.3132 10.7017 11.9942 10.5031 12.6503 10.4023ZM13.0219 12.3143C12.8754 12.3508 12.728 12.401 12.6059 12.4928C12.3714 12.6685 12.2609 12.9735 12.2689 13.2602C12.2651 14.3527 12.2665 15.4457 12.2684 16.5383C12.2548 16.8189 12.3461 17.1159 12.5586 17.3075C12.7959 17.5104 13.1216 17.5661 13.4249 17.5493C13.775 17.5465 14.1461 17.3862 14.3155 17.0658C14.4587 16.8212 14.4367 16.5298 14.4386 16.2576C14.4363 15.2578 14.4424 14.2576 14.4353 13.2574C14.44 12.9163 14.2612 12.5532 13.9383 12.4136C13.657 12.267 13.3275 12.2768 13.0219 12.3143Z'
            fill='white'
          />
          <path
            d='M22.9791 17.5064C23.7233 17.4722 24.4969 17.4924 25.191 17.7936C25.6721 17.9754 26.0947 18.3169 26.3634 18.7573C26.6793 19.268 26.7977 19.8784 26.7902 20.4725C26.7911 21.52 26.7916 22.5671 26.7902 23.6142C26.7949 24.346 26.6053 25.1157 26.1008 25.6667C25.5514 26.2551 24.7342 26.5114 23.9498 26.5554C23.5159 26.6248 23.0769 26.5695 22.6445 26.5231C21.9982 26.4285 21.3406 26.1848 20.8843 25.6995C20.4359 25.2502 20.2323 24.6088 20.1832 23.9881C20.1687 22.8009 20.179 21.6137 20.1771 20.4266C20.1668 19.9388 20.2464 19.4418 20.4574 18.9995C20.6526 18.5652 20.9952 18.2031 21.4019 17.9604C21.883 17.684 22.4315 17.5622 22.9791 17.5064ZM23.1682 19.4324C22.9665 19.4699 22.7681 19.5566 22.6347 19.7168C22.432 19.9299 22.395 20.2392 22.3913 20.5203C22.3913 21.4568 22.3918 22.3938 22.3913 23.3308C22.3899 23.6259 22.381 23.9407 22.5261 24.2083C22.6613 24.4603 22.9337 24.6055 23.2099 24.6444C23.5426 24.6885 23.9105 24.6683 24.1974 24.4758C24.4768 24.2879 24.583 23.9342 24.5816 23.6128C24.5816 22.5498 24.583 21.4872 24.5812 20.4247C24.569 20.152 24.4993 19.8564 24.2844 19.6709C23.9929 19.3846 23.5464 19.3921 23.1682 19.4324Z'
            fill='white'
          />
        </svg>
      ),
    },
    {
      id: 'even',
      label: 'Even',
      icon: (
        <svg
          width='37'
          height='37'
          viewBox='0 0 37 37'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <ellipse
            cx='5.17663'
            cy='12.9637'
            rx='4.67663'
            ry='4.67663'
            fill='#232F3E'
          />
          <ellipse
            cx='31.8236'
            cy='12.9637'
            rx='4.67663'
            ry='4.67663'
            fill='#232F3E'
          />
          <rect
            x='0.5'
            y='17.6406'
            width='36'
            height='2.21312'
            fill='#232F3E'
          />
          <path
            d='M18.4999 19.8535L22.8968 26.4989H14.1031L18.4999 19.8535Z'
            fill='#232F3E'
          />
        </svg>
      ),
      iconActive: (
        <svg
          width='37'
          height='37'
          viewBox='0 0 37 37'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <ellipse
            cx='5.17663'
            cy='12.9637'
            rx='4.67663'
            ry='4.67663'
            fill='white'
          />
          <ellipse
            cx='31.8236'
            cy='12.9637'
            rx='4.67663'
            ry='4.67663'
            fill='white'
          />
          <rect x='0.5' y='17.6406' width='36' height='2.21312' fill='white' />
          <path
            d='M18.4999 19.8535L22.8968 26.4989H14.1031L18.4999 19.8535Z'
            fill='white'
          />
        </svg>
      ),
    },
    {
      id: 'manual',
      label: 'Manual',
      icon: (
        <svg
          width='37'
          height='37'
          viewBox='0 0 37 37'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M2.91778 3.83965C2.88019 2.86682 3.7628 1.96316 4.74314 2.00226C13.2129 1.99925 21.6826 1.99925 30.1523 2.00226C31.1342 1.96015 32.0078 2.86682 31.9792 3.83664C31.9807 8.66167 31.9792 13.4867 31.9792 18.3117C31.2394 18.3057 30.4997 18.3057 29.7599 18.3117C29.7764 13.616 29.7584 8.92029 29.7689 4.22457C21.5608 4.22156 13.3512 4.22607 5.1431 4.22156C5.14009 12.9635 5.14159 21.7038 5.14159 30.4442C9.23738 30.4382 13.3317 30.4427 17.4259 30.4412C17.4214 31.1795 17.4184 31.9163 17.4259 32.6545C13.1527 32.6335 8.87952 32.656 4.60632 32.644C3.64402 32.6215 2.86816 31.6997 2.91778 30.7555C2.91778 21.7835 2.91778 12.8116 2.91778 3.83965Z'
            fill='#232F3E'
          />
          <path
            d='M9.72689 11.3735C10.3103 11.2773 11.2636 11.0623 11.5522 11.7629C11.6169 12.2215 11.6695 12.7313 11.4966 13.1703C11.2124 13.6364 10.617 13.5056 10.1599 13.5161C9.71035 13.5793 9.3164 13.1493 9.37053 12.7087C9.37805 12.2441 9.25927 11.6637 9.72689 11.3735Z'
            fill='#232F3E'
          />
          <path
            d='M13.795 11.3722C14.0701 11.2489 14.3768 11.3015 14.6685 11.291C17.9764 11.294 21.2859 11.2925 24.5938 11.291C25.0523 11.2294 25.4493 11.6654 25.3967 12.1135C25.4613 12.6427 25.4538 13.4682 24.7501 13.5103C21.2377 13.5253 17.7238 13.5133 14.2115 13.5163C13.7679 13.5795 13.3875 13.1404 13.4416 12.7149C13.4476 12.2473 13.3258 11.6669 13.795 11.3722Z'
            fill='#232F3E'
          />
          <path
            d='M9.88695 16.5126C10.4177 16.46 11.1214 16.3186 11.4973 16.8148C11.6657 17.2448 11.6101 17.729 11.5695 18.1786C11.4477 18.7454 10.765 18.7695 10.3019 18.7304C9.85989 18.7965 9.34415 18.4597 9.37573 17.9816C9.35919 17.4598 9.25544 16.7171 9.88695 16.5126Z'
            fill='#232F3E'
          />
          <path
            d='M13.685 16.675C13.8308 16.5592 14.0128 16.4539 14.2082 16.4705C17.7507 16.469 21.2947 16.4735 24.8371 16.469C25.5258 16.7231 25.425 17.532 25.3935 18.1214C25.3469 18.5003 24.9619 18.7409 24.5996 18.7259C21.1323 18.7244 17.665 18.7274 14.1977 18.7259C13.8128 18.7304 13.4128 18.383 13.4459 17.9831C13.4745 17.5455 13.3031 17.0012 13.685 16.675Z'
            fill='#232F3E'
          />
          <path
            d='M31.0659 20.2293C31.3246 19.915 31.8583 19.924 32.1139 20.2383C32.7635 20.9029 33.4657 21.5179 34.0716 22.223C34.0716 22.3975 34.0716 22.5734 34.0701 22.7493C33.7709 23.1087 33.4431 23.4455 33.1018 23.7657C32.8251 24.0334 32.3395 24.0108 32.0884 23.7176C31.5065 23.1402 30.9186 22.5674 30.3397 21.9885C30.1187 21.784 30.0706 21.4562 30.1698 21.1826C30.4344 20.8337 30.7622 20.542 31.0659 20.2293Z'
            fill='#232F3E'
          />
          <path
            d='M9.73669 21.7471C10.1607 21.6088 10.6208 21.6674 11.0568 21.69C11.6869 21.8433 11.6177 22.5906 11.5981 23.0898C11.6312 23.4807 11.317 23.8987 10.908 23.8837C10.3757 23.8867 9.59836 24.0401 9.39688 23.383C9.38786 22.8327 9.19089 22.108 9.73669 21.7471Z'
            fill='#232F3E'
          />
          <path
            d='M13.7995 21.7476C14.0265 21.6529 14.2776 21.6695 14.5182 21.6649C17.8772 21.671 21.2362 21.6664 24.5938 21.6679C25.0463 21.6198 25.4628 22.0258 25.4072 22.4829C25.4598 23.0167 25.4508 23.8557 24.7351 23.8812C21.2272 23.8963 17.7193 23.8842 14.2115 23.8873C13.7739 23.9459 13.389 23.5159 13.4416 23.0919C13.4416 22.6227 13.3379 22.0469 13.7995 21.7476Z'
            fill='#232F3E'
          />
          <path
            d='M28.6598 22.6635C28.9094 22.3417 29.4447 22.3207 29.7213 22.6199C30.3108 23.1868 30.9047 23.7506 31.4821 24.331C31.8144 24.6152 31.7888 25.1715 31.4505 25.4391C28.6162 28.3351 25.7579 31.2084 22.9056 34.0848C21.7012 34.4291 20.4652 34.6682 19.2563 35.0005C19.536 33.7916 19.7886 32.5782 20.0908 31.3753C22.9026 28.4298 25.7985 25.5624 28.6598 22.6635ZM20.6592 31.9452C20.5224 32.6504 20.3314 33.3435 20.2021 34.0502C20.8908 33.8743 21.5809 33.7104 22.2726 33.5435C21.7403 33.0052 21.1824 32.4925 20.6592 31.9452Z'
            fill='#232F3E'
          />
        </svg>
      ),
      iconActive: (
        <svg
          width='37'
          height='37'
          viewBox='0 0 37 37'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M2.91778 3.83965C2.88019 2.86682 3.7628 1.96316 4.74314 2.00226C13.2129 1.99925 21.6826 1.99925 30.1523 2.00226C31.1342 1.96015 32.0078 2.86682 31.9792 3.83664C31.9807 8.66167 31.9792 13.4867 31.9792 18.3117C31.2394 18.3057 30.4997 18.3057 29.7599 18.3117C29.7764 13.616 29.7584 8.92029 29.7689 4.22457C21.5608 4.22156 13.3512 4.22607 5.1431 4.22156C5.14009 12.9635 5.14159 21.7038 5.14159 30.4442C9.23738 30.4382 13.3317 30.4427 17.4259 30.4412C17.4214 31.1795 17.4184 31.9163 17.4259 32.6545C13.1527 32.6335 8.87952 32.656 4.60632 32.644C3.64402 32.6215 2.86816 31.6997 2.91778 30.7555C2.91778 21.7835 2.91778 12.8116 2.91778 3.83965Z'
            fill='white'
          />
          <path
            d='M9.72689 11.3735C10.3103 11.2773 11.2636 11.0623 11.5522 11.7629C11.6169 12.2215 11.6695 12.7313 11.4966 13.1703C11.2124 13.6364 10.617 13.5056 10.1599 13.5161C9.71035 13.5793 9.3164 13.1493 9.37053 12.7087C9.37805 12.2441 9.25927 11.6637 9.72689 11.3735Z'
            fill='white'
          />
          <path
            d='M13.795 11.3722C14.0701 11.2489 14.3768 11.3015 14.6685 11.291C17.9764 11.294 21.2859 11.2925 24.5938 11.291C25.0523 11.2294 25.4493 11.6654 25.3967 12.1135C25.4613 12.6427 25.4538 13.4682 24.7501 13.5103C21.2377 13.5253 17.7238 13.5133 14.2115 13.5163C13.7679 13.5795 13.3875 13.1404 13.4416 12.7149C13.4476 12.2473 13.3258 11.6669 13.795 11.3722Z'
            fill='white'
          />
          <path
            d='M9.88695 16.5126C10.4177 16.46 11.1214 16.3186 11.4973 16.8148C11.6657 17.2448 11.6101 17.729 11.5695 18.1786C11.4477 18.7454 10.765 18.7695 10.3019 18.7304C9.85989 18.7965 9.34415 18.4597 9.37573 17.9816C9.35919 17.4598 9.25544 16.7171 9.88695 16.5126Z'
            fill='white'
          />
          <path
            d='M13.685 16.675C13.8308 16.5592 14.0128 16.4539 14.2082 16.4705C17.7507 16.469 21.2947 16.4735 24.8371 16.469C25.5258 16.7231 25.425 17.532 25.3935 18.1214C25.3469 18.5003 24.9619 18.7409 24.5996 18.7259C21.1323 18.7244 17.665 18.7274 14.1977 18.7259C13.8128 18.7304 13.4128 18.383 13.4459 17.9831C13.4745 17.5455 13.3031 17.0012 13.685 16.675Z'
            fill='white'
          />
          <path
            d='M31.0659 20.2293C31.3246 19.915 31.8583 19.924 32.1139 20.2383C32.7635 20.9029 33.4657 21.5179 34.0716 22.223C34.0716 22.3975 34.0716 22.5734 34.0701 22.7493C33.7709 23.1087 33.4431 23.4455 33.1018 23.7657C32.8251 24.0334 32.3395 24.0108 32.0884 23.7176C31.5065 23.1402 30.9186 22.5674 30.3397 21.9885C30.1187 21.784 30.0706 21.4562 30.1698 21.1826C30.4344 20.8337 30.7622 20.542 31.0659 20.2293Z'
            fill='white'
          />
          <path
            d='M9.73669 21.7471C10.1607 21.6088 10.6208 21.6674 11.0568 21.69C11.6869 21.8433 11.6177 22.5906 11.5981 23.0898C11.6312 23.4807 11.317 23.8987 10.908 23.8837C10.3757 23.8867 9.59836 24.0401 9.39688 23.383C9.38786 22.8327 9.19089 22.108 9.73669 21.7471Z'
            fill='white'
          />
          <path
            d='M13.7995 21.7476C14.0265 21.6529 14.2776 21.6695 14.5182 21.6649C17.8772 21.671 21.2362 21.6664 24.5938 21.6679C25.0463 21.6198 25.4628 22.0258 25.4072 22.4829C25.4598 23.0167 25.4508 23.8557 24.7351 23.8812C21.2272 23.8963 17.7193 23.8842 14.2115 23.8873C13.7739 23.9459 13.389 23.5159 13.4416 23.0919C13.4416 22.6227 13.3379 22.0469 13.7995 21.7476Z'
            fill='white'
          />
          <path
            d='M28.6598 22.6635C28.9094 22.3417 29.4447 22.3207 29.7213 22.6199C30.3108 23.1868 30.9047 23.7506 31.4821 24.331C31.8144 24.6152 31.7888 25.1715 31.4505 25.4391C28.6162 28.3351 25.7579 31.2084 22.9056 34.0848C21.7012 34.4291 20.4652 34.6682 19.2563 35.0005C19.536 33.7916 19.7886 32.5782 20.0908 31.3753C22.9026 28.4298 25.7985 25.5624 28.6598 22.6635ZM20.6592 31.9452C20.5224 32.6504 20.3314 33.3435 20.2021 34.0502C20.8908 33.8743 21.5809 33.7104 22.2726 33.5435C21.7403 33.0052 21.1824 32.4925 20.6592 31.9452Z'
            fill='white'
          />
        </svg>
      ),
    },
  ];

  return (
    <div className='split-tip-split-methods'>
      {methods.map((method) => (
        <div
          key={method.id}
          className={`split-tip-method ${
            selectedMethod === method.id ? 'selected' : ''
          }`}
          onClick={() => onMethodChange(method.id)}
        >
          <div className={`split-method-icon`}>
            {selectedMethod === method.id ? method.iconActive : method.icon}
          </div>
          <span>{method.label}</span>
          {selectedMethod === method.id && (
            <div className='split-method-checkmark'>
              <svg
                width='28'
                height='29'
                viewBox='0 0 28 29'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <circle
                  cx='14'
                  cy='14.0898'
                  r='13.5'
                  fill='#0C719C'
                  stroke='white'
                />
                <path
                  fill-rule='evenodd'
                  clip-rule='evenodd'
                  d='M21.9939 7.52542C22.3056 7.79818 22.3372 8.27201 22.0644 8.58373L11.5644 20.5837C11.4277 20.74 11.2324 20.8325 11.025 20.8394C10.8175 20.8463 10.6164 20.767 10.4697 20.6202L5.96967 16.1202C5.67678 15.8273 5.67678 15.3524 5.96967 15.0595C6.26256 14.7666 6.73744 14.7666 7.03033 15.0595L10.9635 18.9927L20.9356 7.59598C21.2083 7.28425 21.6822 7.25266 21.9939 7.52542Z'
                  fill='white'
                />
              </svg>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default SplitMethodSelector;
